/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

 jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

 /**
  * Module to show Recently Viewed Products
  *
  * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
  * Dual licensed under the MIT and GPL licenses:
  * http://www.opensource.org/licenses/mit-license.php
  * http://www.gnu.org/licenses/gpl.html
  *
  */
 
 Shopify.Products = (function() {
     var defaultConfig = {
         howManyToShow: 3,
         howManyToStoreInMemory: 10,
         wrapperId: 'recently-viewed-products',
         templateId: 'recently-viewed-product-template',
         layout: 'slider',
         swipe: true,
         media: 'adapt',
         onComplete: null
     };
     // Kept only so getConfig() still reflects the most recent call, each
     // showRecentlyViewed() call otherwise works off its own local state so that
     // concurrent callers (the recently-viewed popup and the on-page section)
     // don't stomp on each other's in-flight requests.
     var config = jQuery.extend({}, defaultConfig);

     var getCurrentProductHandle = function() {
         if (window.location.pathname.indexOf('/products/') === -1) return null;
         var splitted = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
         return splitted ? splitted[1] : decodeURIComponent(window.location.pathname.split('/products/')[1]);
     };

     // Recently viewed relies on Shopify's Customer Privacy API (which apps
     // like Complianz plug into) rather than its own consent UI. "preferences"
     // is the category Shopify documents for personalisation cookies, which is
     // what this feature is. If the API hasn't loaded yet we fail open so the
     // feature still works on stores that haven't configured a consent banner.
     var isPreferencesAllowed = function() {
         if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.preferencesProcessingAllowed === 'function') {
             return window.Shopify.customerPrivacy.preferencesProcessingAllowed();
         }
         return true;
     };

     var cookie = {
         configuration: {
             expires: 90,
             path: '/',
             domain: window.location.hostname
         },
         name: 'shopify_recently_viewed',
         write: function(recentlyViewed) {
             jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
         },
         read: function() {
             var recentlyViewed = [];
             var cookieValue = jQuery.cookie(this.name);
             if (cookieValue !== null) {
                 recentlyViewed = cookieValue.split(' ');
             }
             return recentlyViewed;
         },
         destroy: function() {
             jQuery.cookie(this.name, null, this.configuration);
         },
         remove: function(productHandle) {
             var recentlyViewed = this.read();
             var position = jQuery.inArray(productHandle, recentlyViewed);
             if (position !== -1) {
                 recentlyViewed.splice(position, 1);
                 this.write(recentlyViewed);
             }
         }
     };
 
     var finalize = function(state) {
         var items = state.wrapper.find('.item, .product');
         var block = state.wrapper.closest('[data-recently-viewed-block]');

         if (items.length <= 2) $('#recently-viewed-products-list').addClass('center');

         $('#' + state.config.wrapperId).addClass('recently-viewed-loaded');

         if (items.length === 0) {
             // Nothing left to show (eg. the only product ever viewed is the
             // one currently being looked at) - hide the block instead of
             // leaving an empty "Recently Viewed" section on the page.
             if (block.length) block.hide();
             else state.wrapper.show();
         } else {
             state.wrapper.show();
             block.show();
         }

         // If we have a callback.
         if (state.config.onComplete) {
             try {
                 state.config.onComplete();
             } catch (error) {}
         }
     };

     var moveAlong = function(state) {
         if (state.queue.length && state.shown < state.config.howManyToShow) {
             var url = window.routes.root + '/products/' + state.queue[0] + '?view=ajax_recently_viewed';

             jQuery.ajax({
                 type: 'get',
                 url: url,
                 cache: false,
                 success: function(product) {
                     state.wrapper.append(product);
                     state.queue.shift();
                     state.shown++;
                     moveAlong(state);
                 },
                 error: function() {
                     cookie.remove(state.queue[0]);
                     state.queue.shift();
                     moveAlong(state);
                 }
             });
         } else {
             finalize(state);
         }
     };

     var initSliderIfNeeded = function(state) {
         if (state.config.layout != 'slider') return;

         var wrapper = $('.halo-recently-viewed-block'),
             productGrid = wrapper.find('.products-carousel'),
             itemToShow = productGrid.data('item-to-show'),
             itemDots = productGrid.data('item-dots'),
             itemDotsMb = productGrid.data('item-dots-mb'),
             itemArrows = productGrid.data('item-arrows'),
             itemArrowsMb = productGrid.data('item-arrows-mb');

         if (productGrid.length > 0) {
             if (productGrid.not('.slick-initialized')) {
                 productGrid.slick({
                     mobileFirst: true,
                     adaptiveHeight: true,
                     vertical: false,
                     infinite: true,
                     slidesToShow: 1,
                     slidesToScroll: 1,
                     arrows: itemArrowsMb,
                     dots: itemDotsMb,
                     nextArrow: window.arrows.icon_next,
                     prevArrow: window.arrows.icon_prev,
                     rtl: window.rtl_slick,
                     responsive:
                     [
                         {
                             breakpoint: 1599,
                             settings: {
                                 arrows: itemArrows,
                                 dots: itemDots,
                                 get slidesToShow() {
                                     if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                         return this.slidesToShow = itemToShow;
                                     } else {
                                         return this.slidesToShow = 1;
                                     }
                                 },
                                 get slidesToScroll() {
                                     if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                         return this.slidesToScroll = itemToShow;
                                     } else {
                                         return this.slidesToScroll = 1;
                                     }
                                 }
                             }
                         },
                         {
                             breakpoint: 1024,
                             settings: {
                                 arrows: itemArrows,
                                 dots: itemDots,
                                 get slidesToShow() {
                                     if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                         if(itemToShow == 5){
                                             return this.slidesToShow = itemToShow - 1;
                                         } else {
                                             return this.slidesToShow = itemToShow;
                                         }
                                     } else {
                                         return this.slidesToShow = 1;
                                     }
                                 },
                                 get slidesToScroll() {
                                     if(itemToShow !== undefined && itemToShow !== null && itemToShow !== ''){
                                         if(itemToShow == 5){
                                             return this.slidesToScroll = itemToShow - 1;
                                         } else {
                                             return this.slidesToScroll = itemToShow;
                                         }
                                     } else {
                                         return this.slidesToScroll = 1;
                                     }
                                 }
                             }
                         },
                         {
                             breakpoint: 991,
                             settings: {
                                 arrows: itemArrowsMb,
                                 dots: itemDotsMb,
                                 slidesToShow: 4,
                                 slidesToScroll: 4
                             }
                         },
                         {
                             breakpoint: 767,
                             settings: {
                                 arrows: itemArrowsMb,
                                 dots: itemDotsMb,
                                 slidesToShow: 3,
                                 slidesToScroll: 3
                             }
                         },
                         {
                             breakpoint: 320,
                             settings: {
                                 arrows: itemArrowsMb,
                                 dots: itemDotsMb,
                                 slidesToShow: 2,
                                 slidesToScroll: 2
                             }
                         }
                     ]
                 });
             }
         }
     };

     // Fetches each product individually via the same per-product alternate-view
     // mechanism the popup uses (moveAlong), rather than batching through
     // /collections/all with a fabricated "constraint" tag: Shopify silently
     // 301-redirects any request carrying a `constraint` query param (stripping
     // it) and current_tags never reflects tag values that aren't real product
     // tags, so that batched approach always came back empty.
     var doAlong = function(state) {
         if (state.queue.length && state.shown < state.config.howManyToShow) {
             var handle = state.queue[0];
             var url = window.routes.root + '/products/' + handle + '?view=ajax_recently_viewed_grid';

             jQuery.ajax({
                 type: 'get',
                 url: url,
                 cache: false,
                 success: function(product) {
                     var $product = $(product);
                     if (state.config.swipe) $product.addClass('slider__slide grid__item');
                     state.wrapper.append($product);
                     state.queue.shift();
                     state.shown++;
                     doAlong(state);
                 },
                 error: function() {
                     cookie.remove(state.queue[0]);
                     state.queue.shift();
                     doAlong(state);
                 }
             });
         } else {
             initSliderIfNeeded(state);
             finalize(state);
         }
     };
 
     return {
         resizeImage: function(src, size) {
             if (size == null) {
                 return src;
             }
 
             if (size == 'master') {
                 return src.replace(/http(s)?:/, "");
             }
 
             var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
 
             if (match != null) {
                 var prefix = src.split(match[0]);
                 var suffix = match[0];
 
                 return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
             } else {
                 return null;
             }
         },
 
         showRecentlyViewed: function(params) {
             var params = params || {};

             // Each call gets its own config/queue/wrapper instead of sharing
             // module state, so the popup widget and the on-page section can
             // both be loading their lists at the same time without clobbering
             // each other.
             var callConfig = jQuery.extend({}, defaultConfig, params);
             config = callConfig;

             // If consent has been denied/revoked, drop any leftover cookie so
             // nothing renders and it won't reappear on the next page load.
             if (!isPreferencesAllowed()) {
                 cookie.destroy();
             }

             // Read cookie, and drop the product being currently viewed so it
             // never shows up in its own recently-viewed list.
             var queue = cookie.read();
             var currentHandle = getCurrentProductHandle();
             if (currentHandle) {
                 queue = jQuery.grep(queue, function(handle) {
                     return handle !== currentHandle;
                 });
             }

             var wrapper = jQuery('#' + callConfig.wrapperId);

             // How many products to show.
             callConfig.howManyToShow = Math.min(queue.length, callConfig.howManyToShow);

             if (!wrapper.length) return;

             var state = { config: callConfig, queue: queue, wrapper: wrapper, shown: 0 };

             // If we have any to show.
             if (callConfig.howManyToShow) {
                 // Getting each product with an Ajax call and rendering it on the page.
                 if (callConfig.templateId == 'recently-viewed-product-popup'){
                     moveAlong(state);
                 } else {
                     // Clear the server-rendered loading skeletons before
                     // appending the real products doAlong fetches one by one.
                     wrapper.empty();
                     doAlong(state);
                 }
             } else {
                 // The section pre-renders loading skeletons server-side; clear
                 // them out since we're not fetching anything to replace them.
                 // The popup's wrapper only ever holds its "no products" markup,
                 // which should be left alone.
                 if (callConfig.templateId != 'recently-viewed-product-popup') wrapper.empty();
                 finalize(state);
             }
         },

         getConfig: function() {
             return config;
         },

         clearList: function() {
             cookie.destroy();
         },

         recordRecentlyViewed: function(params) {
             var params = params || {};

             // Respect denied/not-yet-decided consent: don't track anything,
             // and clear out any cookie written before consent was withdrawn.
             if (!isPreferencesAllowed()) {
                 cookie.destroy();
                 return;
             }

             // Update defaults.
             jQuery.extend(config, params);

             // Read cookie.
             var recentlyViewed = cookie.read();

             // If we are on a product page.
             var productHandle = getCurrentProductHandle();
             if (productHandle) {
                 // In what position is that product in memory.
                 var position = jQuery.inArray(productHandle, recentlyViewed);
                 // If not in memory.
                 if (position === -1) {
                     // Add product at the start of the list.
                     recentlyViewed.unshift(productHandle);
                     // Only keep what we need.
                     recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                 } else {
                     // Remove the product and place it at start of list.
                     recentlyViewed.splice(position, 1);
                     recentlyViewed.unshift(productHandle);
                 }
 
                 // Update cookie.
                 cookie.write(recentlyViewed);
             }
         }
     };
 })();